/**
 * Decode the JWT and return  a decoded obj.
 * @param  {String} token - The encoded token.
 * @returns {Object} - the decoded token as json.
 */
const decodeJWT = (token) => {
    if (typeof token !== 'string') {
        return null;
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};

/**
 * Get the expiration date.
 * @param  {String} token - The encoded token.
 * @returns {Date}       [description]
 */
const getTokenExpirationDate = (token) => {
    let decoded = null;

    try {
        decoded = decodeJWT(token);
    } catch (error) {
        // So we could get a better sentry report if someone tries to tamper the token
        throw new Error(`WARNING: Invalid token couldn't be decoded: ${token}`);
    }

    if (decoded === null || decoded.exp === null) {
        return null;
    }

    // The 0 here is the key, which sets the date to the epoch
    const expirationDate = new Date(0);
    expirationDate.setUTCSeconds(decoded.exp);

    return expirationDate;
};

/**
 * Check if the token is expired.
 * @param  {String} token - The encoded token.
 * @returns {Boolean} - True if the token is expired.
 */
export const isTokenExpired = (token) => {
    const expirationDate = getTokenExpirationDate(token);

    if (expirationDate === null) {
        return false;
    }

    return !(expirationDate.valueOf() > new Date().valueOf());
};
